import React, {useState} from 'react'
import styled from 'styled-components'
import H2 from '../../commons/H2'
import H4 from '../../commons/H4'
import Link from '../../commons/Link'
import PensionatiText from './PensionatiText'
import DipendentiPubbliciText from './DipendentiPubbliciText'
import DipendentiPrivatiText from './DipendentiPrivatiText'
import AdvantagesText from './AdvantagesText'
import ReferenceRegulationText from './ReferenceRegulationText'
import PayrollDeductionLoanText from './PayrollDeductionLoanText'
import HowDoesItWorkText from './HowDoesItWorkText'
import ExamplesText from './ExamplesText'
import pensionatoIcon from '../../../img/pensionato_bl_2x.png'
import stataleIcon from '../../../img/pubblico_bl_2x.png'
import privatoIcon from '../../../img/privati_bl_2x.png'
import {useNavigate} from 'react-router-dom'

const TripleTab = () => {
  const [tabToShow, setTabToShow] = useState(1)
  const navigate = useNavigate()

  // Frecce fra i tab; Tab esce dalla tablist (pattern Tabs WAI-ARIA).
  const handleTabKeyDown = (e: React.KeyboardEvent<HTMLElement>) => {
    const totale = 3
    let prossimo: number | null = null
    if (e.key === 'ArrowRight') prossimo = (tabToShow % totale) + 1
    else if (e.key === 'ArrowLeft') prossimo = ((tabToShow - 2 + totale) % totale) + 1
    else if (e.key === 'Home') prossimo = 1
    else if (e.key === 'End') prossimo = totale
    if (prossimo === null) return
    e.preventDefault()
    setTabToShow(prossimo)
    document.getElementById(['tab-pensionato', 'tab-statale', 'tab-privato'][prossimo - 1])?.focus()
  }

  return (
    <>
      <Container>
        <Row>
          <Title>
            <H2>SCOPRI IL SERVIZIO CHE FA PER TE IN BASE AL TUO PROFILO</H2>
          </Title>
        </Row>
        <IconsContainer>
          <IconsInnerContainer>
            <IconsRow role="tablist" aria-label="Scopri il servizio in base al tuo profilo">
              <SwitchContainer>
                <Switch
                  type="button"
                  role="tab"
                  id="tab-pensionato"
                  aria-selected={tabToShow === 1}
                  aria-controls="panel-pensionato"
                  tabIndex={tabToShow === 1 ? 0 : -1}
                  onClick={() => setTabToShow(1)}
                  onKeyDown={handleTabKeyDown}
                  isSelected={tabToShow === 1}
                >
                  <ImgContainer>
                    <Img src={pensionatoIcon} alt={'Un uomo pensionato mentre parla al telefono'}/>
                  </ImgContainer>
                  <H4 as="h3">SOLUZIONI PER<Span isSelected={tabToShow === 1}>PENSIONATO</Span></H4>
                </Switch>
              </SwitchContainer>
              <SwitchContainer>
                <Switch
                  type="button"
                  role="tab"
                  id="tab-statale"
                  aria-selected={tabToShow === 2}
                  aria-controls="panel-statale"
                  tabIndex={tabToShow === 2 ? 0 : -1}
                  onClick={() => setTabToShow(2)}
                  onKeyDown={handleTabKeyDown}
                  isSelected={tabToShow === 2}
                >
                  <ImgContainer>
                    <Img src={stataleIcon} alt={'Un dottore mentre parla al telefono'}/>
                  </ImgContainer>
                  <H4 as="h3">SOLUZIONI PER<Span isSelected={tabToShow === 2}>DIPENDENTE STATALE / PUBBLICO</Span></H4>
                </Switch>
              </SwitchContainer>
              <SwitchContainer>
                <Switch
                  type="button"
                  role="tab"
                  id="tab-privato"
                  aria-selected={tabToShow === 3}
                  aria-controls="panel-privato"
                  tabIndex={tabToShow === 3 ? 0 : -1}
                  onClick={() => setTabToShow(3)}
                  onKeyDown={handleTabKeyDown}
                  isSelected={tabToShow === 3}
                >
                  <ImgContainer>
                    <Img src={privatoIcon} alt={''}/> {/*Una donna vestita elegante che indossa occhiali*/}
                  </ImgContainer>
                  <H4 as="h3">SOLUZIONI PER<Span isSelected={tabToShow === 3}>DIPENDENTE DI SOCIETÀ SPA/SRL</Span></H4>
                </Switch>
              </SwitchContainer>
            </IconsRow>
          </IconsInnerContainer>
        </IconsContainer>
      </Container>
      <Article>
        <AdvantagesContainer>
          <AdvantagesRow>
            <Advantages>
              <div>
                <Tab
                  role="tabpanel"
                  id="panel-pensionato"
                  aria-labelledby="tab-pensionato"
                  tabIndex={0}
                  isActive={tabToShow === 1}
                >
                  <ReferenceRegulationText/>
                  <PayrollDeductionLoanText/>
                  <HowDoesItWorkText/>
                  <ExamplesText/>
                  <AdvantagesText/>
                  <PensionatiText/>
                </Tab>
                <Tab
                  role="tabpanel"
                  id="panel-statale"
                  aria-labelledby="tab-statale"
                  tabIndex={0}
                  isActive={tabToShow === 2}
                >
                  <ReferenceRegulationText/>
                  <PayrollDeductionLoanText/>
                  <HowDoesItWorkText/>
                  <ExamplesText/>
                  <AdvantagesText/>
                  <DipendentiPubbliciText/>
                </Tab>
                <Tab
                  role="tabpanel"
                  id="panel-privato"
                  aria-labelledby="tab-privato"
                  tabIndex={0}
                  isActive={tabToShow === 3}
                >
                  <ReferenceRegulationText/>
                  <PayrollDeductionLoanText/>
                  <HowDoesItWorkText/>
                  <ExamplesText/>
                  <AdvantagesText/>
                  <DipendentiPrivatiText/>
                </Tab>
              </div>
            </Advantages>
            <LinkContainer>
              <Link text={'CHIEDI SUBITO UN PREVENTIVO GRATUITO'} onClick={() => navigate('/preventivatore')}/>
            </LinkContainer>
          </AdvantagesRow>
        </AdvantagesContainer>
      </Article>
    </>
  )
}

// region Style
const Container = styled.div`
  max-width: 1140px;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
`
const Row = styled.div`
  padding-top: 3rem !important;
  margin-top: 3rem !important;
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
`
const Title = styled.div`
  text-align: center !important;
  flex: 0 0 100%;
  max-width: 100%;
`
const IconsContainer = styled.div`
  padding-top: 1rem !important;
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
`
const IconsInnerContainer = styled.div`
  @media (min-width: 768px){
    margin-left: 8.33333%;
  }
  @media (min-width: 768px){
    flex: 0 0 83.33333%;
    max-width: 83.33333%;
  }
  flex: 0 0 100%;
  max-width: 100%;
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
`
const IconsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
`
const SwitchContainer = styled.div`
  @media (min-width: 768px){
    margin-bottom: 0 !important;
  }
  margin-bottom: 3rem !important;
  flex: 0 0 33.33333%;
  max-width: 33.33333%;
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
`
const Switch = styled.button<any>`
  width: 100%;
  border: 0;
  background: transparent;
  /* Su main questo era un <div>. Il browser mette sui controlli di form un
     padding di 1px 6px e un font proprio (13.33px, line-height normal): senza
     questi reset la scheda si spostava di qualche pixel rispetto a main.
     Misurato su /quinto-puoi con il confronto pixel. */
  padding: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  color: inherit;

  &:focus {
    outline: none;
  }
  &:focus-visible {
    outline: 3px solid #005fcc;
    outline-offset: 2px;
  }

  img {
    ${props => props.isSelected ? 'transform: scale(1.1);' : ''};
    //transform: scale(1.1); 
  }
  ${props => props.isSelected ? 'border-bottom: 5px solid #FCBB00' : ''};
  text-align: center;
  display: block;
  margin-bottom: -3px;
  text-decoration: none;
  @media (min-width: 768px) {
    padding-bottom: 1.5rem !important;
  }
  padding-bottom: 0 !important;
  cursor: pointer;
`
const ImgContainer = styled.div`
  display: inline-block;
  margin-bottom: 1rem;
  max-width: 15.8rem;
`
const Img = styled.img`
  transition: all .3s ease-in-out;
  border-style: none;
  max-width: 100%;
`
const Span = styled.span<any>`
  /*${props => props.isSelected ? 'color: #FCBB00' : ''};*/
  color: #222;
  display: block;
`
const Article = styled.div`
  @media (min-width: 993px) {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  background-position: center center;
  background-size: cover;
  background-color: #fff;
  padding-bottom: 3rem;
  display: block;
  margin-bottom: 5rem;
  padding-left: 1.10294rem;
  padding-right: 1.10294rem;
`
const AdvantagesContainer = styled.div`
  max-width: 1140px;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
`
const AdvantagesRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
`
const Advantages = styled.div`
  @media (min-width: 768px) {
    margin-left: 8.33333%;
  }
  @media (min-width: 768px){
    flex: 0 0 83.33333%;
    max-width: 83.33333%;
  }
  padding-bottom: 3rem !important;
  flex: 0 0 100%;
  max-width: 100%;
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
`
const Tab = styled.div<any>`
  text-align: initial;
  ${props => props.isActive ? 'display: block' : 'display: none'};
  @media (prefers-reduced-motion: reduce){
   transition: none;
  }
  transition: opacity 0.15s linear;
`
const LinkContainer = styled.div`
  text-align: center !important;
  flex: 0 0 100%;
  max-width: 100%;
`
// endregion

export default TripleTab
